import React from 'react';
import 'simplebar/dist/simplebar.min.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { throttle } from 'lodash';
import { Amplify } from 'aws-amplify';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import store from './store';
import './App.css';
import './components/CustomComponents/GoogleTranslate/style.css';
import envFunc from './envUtils';
import { saveState } from './localStorage';
import { refreshToken } from './actions/loginActions';
import config from './configs/awsConfig';
// ----------------------------------------------------------------------

Amplify.configure(config);

store.subscribe(
  throttle(() => {
    saveState({
      loginReducer: store.getState().loginReducer
    });
  }, 1000)
);
envFunc();
store.dispatch(
  refreshToken(
    () => {},
    (data) => {
      console.log(data);
    }
  )
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);

reportWebVitals();

// award operation medal type change sayfa bazli yapalim
